import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { AccountService } from "../services/account.service";


@Injectable()
export class SessionCreditResolve implements Resolve<any> {

    constructor(private accService: AccountService) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let creditId = route.params['creditid']
        if (creditId == null) {
            return null;
        }

        return new Promise<any>((resolve, reject) => {
            this.accService.isSessionCreditValid(creditId).subscribe(
                (data) => {
                    resolve(data);
                });
        }).then(function (data) {
            return data;
        });

    }

}
